/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  UpdateRoutineMutationRequest,
  UpdateRoutineMutationResponse,
  UpdateRoutinePathParams,
  UpdateRoutine400,
  UpdateRoutine401,
  UpdateRoutine403,
  UpdateRoutine404,
} from '../types/UpdateRoutine.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getUpdateRoutineUrl(id: UpdateRoutinePathParams['id']) {
  const res = { method: 'PUT', url: `/routines/${id}` as const };
  return res;
}

/**
 * @summary Update routine
 * {@link /routines/:id}
 */
export async function updateRoutine(
  id: UpdateRoutinePathParams['id'],
  data: UpdateRoutineMutationRequest,
  config: Partial<RequestConfig<UpdateRoutineMutationRequest>> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    UpdateRoutineMutationResponse,
    ResponseErrorConfig<UpdateRoutine400 | UpdateRoutine401 | UpdateRoutine403 | UpdateRoutine404>,
    UpdateRoutineMutationRequest
  >({ method: 'PUT', url: getUpdateRoutineUrl(id).url.toString(), data: requestData, ...requestConfig });
  return res.data;
}
